import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Button } from '@/components/ui/button';
import { ArrowUpDown, ArrowUp, ArrowDown } from 'lucide-react';

export type SortField = 'date' | 'clarity' | 'phase' | 'title';
export type SortDirection = 'asc' | 'desc';

export interface SortOptions {
  field: SortField;
  direction: SortDirection;
}

interface SessionSortProps {
  sortOptions: SortOptions;
  onSortChange: (options: SortOptions) => void;
}

const SORT_OPTIONS = [
  { value: 'date', label: 'Datum' },
  { value: 'clarity', label: 'Clarity Score' },
  { value: 'phase', label: 'Phase' },
  { value: 'title', label: 'Alphabetisch' },
];

export const SessionSort = ({ sortOptions, onSortChange }: SessionSortProps) => {
  const toggleDirection = () => {
    onSortChange({
      ...sortOptions,
      direction: sortOptions.direction === 'asc' ? 'desc' : 'asc',
    });
  };

  const handleFieldChange = (value: string) => {
    onSortChange({
      ...sortOptions,
      field: value as SortField,
    });
  };

  const SortIcon = sortOptions.direction === 'asc' ? ArrowUp : ArrowDown;

  return (
    <div className="flex items-center gap-1.5 sm:gap-2">
      <Select value={sortOptions.field} onValueChange={handleFieldChange}>
        <SelectTrigger className="w-[120px] sm:w-[180px] h-10 sm:h-12 rounded-lg sm:rounded-xl border-border/50 bg-card hover:border-primary/30 transition-all text-xs sm:text-sm">
          <div className="flex items-center gap-1.5 sm:gap-2">
            <div className="w-5 h-5 sm:w-6 sm:h-6 rounded-md bg-gradient-to-br from-primary/15 to-primary/5 flex items-center justify-center flex-shrink-0">
              <ArrowUpDown className="h-3 w-3 sm:h-3.5 sm:w-3.5 text-primary" />
            </div>
            <SelectValue />
          </div>
        </SelectTrigger>
        <SelectContent className="rounded-lg sm:rounded-xl border-border/50">
          {SORT_OPTIONS.map((option) => (
            <SelectItem key={option.value} value={option.value} className="rounded-lg text-xs sm:text-sm">
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      <Button
        variant="outline"
        size="icon"
        onClick={toggleDirection}
        className="h-10 w-10 sm:h-12 sm:w-12 rounded-lg sm:rounded-xl border-border/50 hover:border-primary/30 hover:bg-primary/5 hover:text-primary transition-all"
        aria-label={sortOptions.direction === 'asc' ? 'Aufsteigend sortieren' : 'Absteigend sortieren'}
      >
        <SortIcon className="h-3.5 w-3.5 sm:h-4 sm:w-4" />
      </Button>
    </div>
  );
};
